import ScreenBarPartner from "./components/screen-bar-partner";
import Fireworks from "@fireworks-js/react";
import ScreenDonSection from "./components/screen-don-section";
import {useEffect} from "react";
import Head from "next/head";


export default function CustomBrunoy2({context, loading, campagneData}) {

    const screenOptions = campagneData?.screenOptions || {}

    useEffect(() => {
        document.body.style.overflow = "hidden";
        document.body.style.cursor = "none";
    }, []);


    if (loading) {
        return (
            <div className="screen custom-brunoy2-screen" style={{
                aspectRatio: "16/9",
                position: "relative",
                backgroundColor: "#000"
            }}/>
        )
    }


    return (
        <div className="screen custom-brunoy2-screen" style={{
            aspectRatio: "16/9",
            position: "relative",
            overflow: "hidden",
            width: "100vw",
            height: "100vh",
            backgroundImage: "url(/campagne/screen/custom-brunoy2/Galas%20Screens%20brunoy.png)",
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        }}>
            <Head>
                <link
                    rel="preload"
                    href="/campagne/screen/custom-brunoy2/lust-display.otf"
                    as="font"
                    type="font/otf"
                    crossOrigin="anonymous"
                />
                <link
                    rel="preload"
                    href="/campagne/screen/custom-brunoy2/Cera%20Pro%20Bold.otf"
                    as="font"
                    type="font/otf"
                    crossOrigin="anonymous"
                />
                <link
                    rel="preload"
                    href="/campagne/screen/custom-brunoy2/Cera%20Pro%20Thin.otf"
                    as="font"
                    type="font/otf"
                    crossOrigin="anonymous"
                />
                <style dangerouslySetInnerHTML={{__html: `
                    @font-face {
                        font-family: "LustDisplay";
                        src: url("/campagne/screen/custom-brunoy2/lust-display.otf") format("opentype");
                        font-weight: 400;
                        font-style: normal;
                        font-display: block;
                    }
                    @font-face {
                        font-family: "CeraproBrunoy2-Bold";
                        src: url("/campagne/screen/custom-brunoy2/Cera%20Pro%20Bold.otf") format("opentype");
                        font-weight: 700;
                        font-style: normal;
                        font-display: block;
                    }
                    @font-face {
                        font-family: "CeraproBrunoy2-Thin";
                        src: url("/campagne/screen/custom-brunoy2/Cera%20Pro%20Thin.otf") format("opentype");
                        font-weight: 200;
                        font-style: normal;
                        font-display: block;
                    }
                `}}/>
            </Head>

            <style jsx global>{`
                .custom-brunoy2-screen .brunoy2-counter {
                    font-family: "LustDisplay", serif !important;
                }
                .custom-brunoy2-screen .brunoy2-card-amount {
                    font-family: "CeraproBrunoy2-Bold", sans-serif !important;
                }
                .custom-brunoy2-screen .brunoy2-card-name {
                    font-family: "CeraproBrunoy2-Thin", sans-serif !important;
                }

                @keyframes brunoy2ScreenDonFadeIn {
                    from { opacity: 0; transform: translateY(20px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
                .custom-brunoy2-screen .screen-don-card {
                    border-radius: 24px;
                    background-color: #FFFFFF;
                    height: 18vh;
                    min-width: 18vw;
                    max-width: 18vw;
                    overflow: hidden;
                    animation-duration: 1s;
                    animation-fill-mode: both;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 1.8vh;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.25);
                }
                .custom-brunoy2-screen .screen-don-card.screenDonFadeIn {
                    animation-name: brunoy2ScreenDonFadeIn;
                }
                .custom-brunoy2-screen .screen-don-card.screenDonFadeOut {
                    display: none;
                }
            `}</style>

            <div style={{
                position: "absolute",
                inset: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            }}>

                <div style={{marginTop: "25vh", width: "100%"}}>
                    <ScreenBarPartner context={context} campagneData={campagneData} mini={screenOptions.barMini}/>
                </div>


                <div style={{marginTop: "6vh", width: "100%"}}>
                    <ScreenDonSection context={context} campagneData={campagneData}/>
                </div>


                {screenOptions.forceCelebration && (
                    <Fireworks
                        autostart
                        options={{intensity: 30, particles: 100, traceLength: 1, opacity: 0.2}}
                        style={{
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            position: 'fixed',
                            background: 'transparent'
                        }}
                    />
                )}
            </div>
        </div>
    )
}
